import { BehaviorSubject, Observable } from 'rxjs';
import { finalCostModel, nonHostedFinalCostModel, NonHostedQuotation, QuotationEnvironmentsModel, subscriptionPeriodModel } from 'ncache-common-library';
import { EnvironmentsModel } from 'ncache-common-library';

export class QuotationValidationState {
  // Final cost of a quotation
  private finalCost = new BehaviorSubject<finalCostModel | null>(null);
  public finalQuotationCost$ = this.finalCost.asObservable(); 
  
  
  private nonHostedfinalCost = new BehaviorSubject<nonHostedFinalCostModel | null>(null);
  public nonhostedfinalQuotationCost$ = this.nonHostedfinalCost.asObservable();

  // Environment names
  private validateName = new BehaviorSubject<string[] | null>(null);
  public existingEnvironments$ = this.validateName.asObservable();

  // Server profiles
  private serverPlan = new BehaviorSubject<string[] | null>(null);
  public availableServerPlans$ = this.serverPlan.asObservable();

  // Regions
  private regions = new BehaviorSubject<string[] | null>(null);
  public regionsBasedOnServerPlan$ = this.regions.asObservable();

  // Availability Zones
  private availabilityZones = new BehaviorSubject<any | null>(null);
  public availabilityZonesBasedOnRegionsAndServerPlan$ = this.availabilityZones.asObservable();

  // Quotation Environments Array
  private quotationEnvironments = new BehaviorSubject<QuotationEnvironmentsModel[]>([]);
  public quotationEnvironmentsGlobalArray$ = this.quotationEnvironments.asObservable();  
  
  private nonHostedQuotationEnvironments = new BehaviorSubject<NonHostedQuotation[]>([]);
  public nonHostedQuotationEnvironmentsGlobalArray$ = this.nonHostedQuotationEnvironments.asObservable();

  private QuotationCategory =  new BehaviorSubject<string>('');
  public QuotationCategoryGlobal$ = this.QuotationCategory.asObservable();  
  
  private isQuotationModified =  new BehaviorSubject<boolean>(false);
  public isQuotationModified$ = this.isQuotationModified.asObservable();

  private userEmail =  new BehaviorSubject<string>('');
  public userEmail$ = this.userEmail.asObservable();
  
  private cloudProvider =  new BehaviorSubject<string>('');
  public cloudProvider$ = this.cloudProvider.asObservable();

  private planEdition =  new BehaviorSubject<string>('');
  public planEdition$ = this.planEdition.asObservable();

  private subscriptionId =  new BehaviorSubject<string>('');
  public subscriptionId$ = this.subscriptionId.asObservable();

  private quotationId =  new BehaviorSubject<string>('');
  public quotationId$ = this.quotationId.asObservable();

  private subscriptionPeriod =  new BehaviorSubject<subscriptionPeriodModel >(new subscriptionPeriodModel());
  public subscriptionPeriod$ = this.subscriptionPeriod.asObservable(); 
  
  private initiallySelectedEnvironmentForFreeServerTransfer =  new BehaviorSubject<EnvironmentsModel >(new EnvironmentsModel());
  public initiallySelectedEnvironmentForFreeServerTransfer$ = this.initiallySelectedEnvironmentForFreeServerTransfer.asObservable(); 
  
  private selectedEnvrionmentFromSimilarOthetEnvironments =  new BehaviorSubject<EnvironmentsModel >(new EnvironmentsModel());
  public selectedEnvrionmentFromSimilarOthetEnvironments$ = this.selectedEnvrionmentFromSimilarOthetEnvironments.asObservable();  
  
  private transferingOfServers =  new BehaviorSubject<any >(null);
  public transferingOfServers$ = this.transferingOfServers.asObservable();

  
  populateinitiallySelectedEnvironmentForFreeServerTransferd(environmentsModel: EnvironmentsModel) {
    this.initiallySelectedEnvironmentForFreeServerTransfer.next(environmentsModel);
  }

  geinitiallySelectedEnvironmentForFreeServerTransfer()
  {
    return this.initiallySelectedEnvironmentForFreeServerTransfer$
  }  
    
  
  populateselectedEnvrionmentFromSimilarOthetEnvironments(environmentsModel: EnvironmentsModel) {
    this.selectedEnvrionmentFromSimilarOthetEnvironments.next(environmentsModel);
  }

  geselectedEnvrionmentFromSimilarOthetEnvironments()
  {
    return this.selectedEnvrionmentFromSimilarOthetEnvironments$
  }  
    

  populateTransferingOfServers(environment : any) {
    this.transferingOfServers.next(environment);
  }

  geTransferedOfServers()
  {
    return this.transferingOfServers$
  }  
    


  populateSubscriptionPeriod(subsciptionPeriod: subscriptionPeriodModel) {
    this.subscriptionPeriod.next(subsciptionPeriod);
  }

  geSubscriptionPeriod()
  {
    return this.subscriptionPeriod$
  }  
    
  
  populateIsQuotationModified(isQuotationModified: boolean) {
    this.isQuotationModified.next(isQuotationModified);
  }

  geIsQuotationModified()
  {
    return this.isQuotationModified$
  }  
  
  populateCloudProvider(cloudProvider: string) {
    this.cloudProvider.next(cloudProvider);
  }

  getCloudProvider()
  {
    return this.cloudProvider$
  }


  populatPlanEdition(planEdition: string) {
    this.planEdition.next(planEdition);
  }

  getPlanEdition()
  {
    return this.planEdition$
  }


  populateSubscriptionId(subscriptionId: string) {    
    this.subscriptionId.next(subscriptionId);
  }
  
  getSubscriptionId()
  {    
    return this.subscriptionId$
  }

  populateQuotationId(quotationId: string) {
    this.quotationId.next(quotationId);
  }

  getQuotationId()
  {
    return this.quotationId$
  }

  
  populateUserEmail(userEmail: string) {
    this.userEmail.next(userEmail);
  }

  getUserEmail()
  {
    return this.userEmail$
  }


  populateQuotationCategory(newQuotationCategory: string) {
    this.QuotationCategory.next(newQuotationCategory);
  }

  getQuotationCategory()
  {
    return this.QuotationCategoryGlobal$
  }

  // Update the final cost
  updateFinalCost(finalCost: finalCostModel) 
  {
    this.finalCost.next(finalCost);
  }


  updateNonHostedFinalCost(finalCost: nonHostedFinalCostModel) 
  {
    this.nonHostedfinalCost.next(finalCost);
  }

  // Get the final cost
  getFinalCost(): Observable<finalCostModel | null> {    
    return this.finalQuotationCost$;
  }

  getNonHostedFinalCost(): Observable<nonHostedFinalCostModel | null> {    
    return this.nonhostedfinalQuotationCost$;
  }

  // populatee existing environment names (avoiding duplicates)
  populateExistingEnvironments(names: string[]) {
    const currentNames = this.validateName?.getValue() || [];
    const uniqueNames = names?.filter((name) => !currentNames.includes(name));
    const updatedNames = [...currentNames, ...uniqueNames];
    this.validateName.next(updatedNames);
  }

  // Validate if an environment name already exists
  isEnvironmentNameValid(name: string): boolean {
    const currentNames = this.validateName.getValue() || [];
    return !currentNames.includes(name);
  }

  // Populate available server plans (avoiding duplicates)
  populateServerPlans(plans: string[]) {
    const currentPlans = this.serverPlan.getValue() || [];
    const uniquePlans = plans.filter((plan) => !currentPlans.includes(plan));
    const updatedPlans = [...currentPlans, ...uniquePlans];
    this.serverPlan.next(updatedPlans);
  }

  // Populate regions for a server plan (avoiding duplicates)
  populateRegionsForServerPlan(regions: string[]) {
    const currentRegions = this.regions.getValue() || [];
    const uniqueRegions = regions.filter((region) => !currentRegions.includes(region));
    const updatedRegions = [...currentRegions, ...uniqueRegions];
    this.regions.next(updatedRegions);
  }

  // Populate availability zones (avoiding duplicates)
  populateAvailabilityZones(region :string , zones: string[]) {
    let avlZones: any = {};
    avlZones[region] = zones;
    this.availabilityZones.next(avlZones);
  }

  // Populate the global array of quotation environments (avoiding duplicates)
  populateQuotationEnvironments(environments: QuotationEnvironmentsModel[]) {
    const currentEnvironments = this.quotationEnvironments?.getValue() || [];
    const uniqueEnvironments = environments?.filter(
      (env) => !currentEnvironments.some((current) => current.id === env.id)
    );

    if (uniqueEnvironments?.length > 0)
    {
      const updatedEnvironments = [...currentEnvironments, ...uniqueEnvironments];
      this.quotationEnvironments.next(updatedEnvironments);
    }

  }  
  
  populateNHQuotationEnvironments(environments: NonHostedQuotation[]) {
    const currentEnvironments = this.nonHostedQuotationEnvironments?.getValue() || [];
    const uniqueEnvironments = environments?.filter(
      (env) => !currentEnvironments.some((current) => current.id === env.id)
    );

    if (uniqueEnvironments?.length > 0)
    {
      const updatedEnvironments = [...currentEnvironments, ...uniqueEnvironments];
      this.nonHostedQuotationEnvironments.next(updatedEnvironments);
    }

  }

  // Edit a specific quotation environment
  editQuotationEnvironment(updatedEnvironment: QuotationEnvironmentsModel) {
    const currentEnvironments = this.quotationEnvironments?.getValue() || [];
    
    let isChanged = false;
    const updatedEnvironments = currentEnvironments.map(env => {
      if (env.id === updatedEnvironment.id) {
        isChanged = true;
        return { ...env, ...updatedEnvironment };
      }
      else if (env.name === updatedEnvironment.name) 
      {
        isChanged = true;
        return { ...env, ...updatedEnvironment };
      }
      return env;
    });

    if (isChanged) {
      this.quotationEnvironments.next(updatedEnvironments);
    }
  }

  // Get all global environments
  getAllGlobalEnvironments(): Observable<QuotationEnvironmentsModel[]> {
    return this.quotationEnvironmentsGlobalArray$;
  }


  getAllIInvoice(): Observable<NonHostedQuotation[]> {
    return this.nonHostedQuotationEnvironmentsGlobalArray$;
  }

  // Remove a specific quotation environment by name
  removeQuotationEnvironment(name: string) {
    const currentEnvironments = this.quotationEnvironments.getValue() || [];
    const updatedEnvironments = currentEnvironments.filter((env) => env.name !== name);
    this.quotationEnvironments.next(updatedEnvironments);

    // Also remove the environment name from validateName
    const currentNames = this.validateName.getValue() || [];
    const updatedNames = currentNames.filter((envName) => envName !== name);
    this.validateName.next(updatedNames);
  }

  // Reset state for testing or clearing data
  resetQuotationGlobalState() {
    this.resetEnvironmentsNames()
    this.validateName.next(null);
    this.serverPlan.next(null);
    this.regions.next(null);
    this.availabilityZones.next({});
    this.quotationEnvironments.next([]);
    this.nonHostedQuotationEnvironments.next([]);
    this.finalCost.next(null);
    this.nonHostedfinalCost.next(null);
    this.quotationId.next("");
    this.QuotationCategory.next("");
    this.resetQuotationBeingModified()
    this.resetMoveServersProcess()
  }  

  resetQuotationBeingModified()
  {
    this.isQuotationModified.next(false)
  }
  
  resetavailabilityZonesState() {
    this.availabilityZones.next({});
  }   
  
  resetFinalCostState() {
    this.finalCost.next(null);
  } 
  
  resetQuotationEnvironments() {
    this.quotationEnvironments.next([]);
  }  

  resetEnvironmentsNames() {
    this.validateName.next([]);
  }  
  
  resetserverPlan() {
    this.serverPlan.next([]);
  } 
  
  resetRegions() {
    this.regions.next([]);
  }    
  
  
  resetMoveServersProcess() {
    this.selectedEnvrionmentFromSimilarOthetEnvironments.next(new EnvironmentsModel());
    this.initiallySelectedEnvironmentForFreeServerTransfer.next(new EnvironmentsModel());
    this.transferingOfServers.next(null);
  }  
  
  resetSubscriptionId() {
    this.subscriptionId.next("");
  }

  resetQuotationId() {
    this.quotationId.next("");
  }
}

export const quotationGlobalState = new QuotationValidationState();
